import Icon from '../components/Icon.vue'

Icon.register({
  'oil-can': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M629.8 160.3c5.1-1.5 10.2 2.4 10.2 7.7v18.1c0 2.1-0.8 4.2-2.3 5.7l-212.3 214.8c-6 6.1-14.2 9.5-22.8 9.5h-274.6c-17.7 0-32-14.3-32-32v-46.5l-69.7-12.7c-15.2-2.8-26.3-16-26.3-31.5v-95c0-18 14.7-32 31.9-32 1.6 0 4.2 0.2 5.8 0.5l138.3 25.1h56v-48h-56c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-56v48h56.9c8.3 0 21.2 3 28.6 6.8l50.5 25.2zM96 288.7v-62.4l-48-8.7v62.4zM549.3 373.3c0-23.6 42.7-85.3 42.7-85.3s42.7 61.8 42.7 85.3-19.1 42.7-42.7 42.7-42.7-19.1-42.7-42.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/oil-can.js
// module id = 1597
// module chunks = 0